// extracted by mini-css-extract-plugin
export default {"separador":"Separador_separador__5SZAr","titulo":"Separador_titulo__XZpfC","mas":"Separador_mas__8fLu6"};